export default function scrollElementToTop(elementTopPosition: number, offset = 60) {
  const offsetPosition = elementTopPosition + window.pageYOffset - offset;
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
}
